import request from '../utils/http'

// 659 合作商家广告视频-列表
export function getCooperAdverVideoList(data) {
    return request({
        url: '/service/view03/ams_shop_coopmerchants_videos_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_coopmerchants_videospage',
            ...data
        }
    })
}

// 662 合作商家广告视频-查看详情
export function getCooperAdverVideoDetail(data) {
    return request({
        url: '/service/view03/ams_shop_coopmerchants_videos_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_coopmerchants_videosview',
            ...data
        }
    })
}

// 704 合作商家广告视频-修改三个字段
export function editCooperAdverVideo(data) {
    return request({
        url: '/service/view03/ams_shop_coopmerchants_videos_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_coopmerchants_videothree',
            ...data
        }
    })
}